"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// ideally, these would be part of a variant configuration, but currently there is no way to add
// arbitrary data/json to control tower feature definitions.
var defaultActionProxyEndpoints = {
    "ApplyConversationAction": "messaging"
};
var defaultCachedConfig = {
    baseUrl: null,
    isServer: false,
    isFeatureEnabled: function (feature) { return false; },
    actionProxyEndpoints: defaultActionProxyEndpoints,
};
var cachedConfig = defaultCachedConfig;
function initializeServiceRequest(config) {
    cachedConfig = tslib_1.__assign({}, defaultCachedConfig, config);
}
exports.initializeServiceRequest = initializeServiceRequest;
function getConfig() {
    return cachedConfig;
}
exports.getConfig = getConfig;
function setTimezone(timezone) {
    cachedConfig.timezone = timezone;
}
exports.setTimezone = setTimezone;
function setUseJsonNetSerializer(enabled) {
    cachedConfig.useJsonNetSerializer = enabled;
}
exports.setUseJsonNetSerializer = setUseJsonNetSerializer;
function actionProxyPath(action) {
    var path = cachedConfig.actionProxyEndpoints[action];
    return path ? path : null;
}
exports.actionProxyPath = actionProxyPath;
